<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import SimpleCaption from './SimpleCaption.svelte';

  export let value: string;
  export let label = '';
  export let caption = '';
  export let placeholder = 'Enter here';
  export let danger: boolean = false;
  export let required: boolean = false;
  export let dangerMessage: string = '';
  export let readonly: boolean = false;
  export let autofocus: boolean = false;
  export let autocomplete = 'off';
  export let isPassword = false;
  export let pattern: string = null;
  export let inputVerifing: boolean = false;
  export let inputRegex: RegExp = null;
  export let type = '';
  export let name = '';
  export let hideCaption = false;
  export let unround: 'r' | 'l' | null = null;

  let additionalInputClasses = `${unround ? `rounded-${unround}-none` : ''}`;

  const dispatch = createEventDispatcher();

  $: {
    value, label;
    dispatch('change', { value, label });
  }

  function handleSubmit() {
    dispatch('submit', value);
  }

  function verifyInput(event) {
    let pattern = inputRegex;

    let currentValue = value + event.key;

    if (!pattern.test(currentValue)) {
      event.preventDefault();
    }
  }
</script>

{#if !isPassword}
  <div class="flex flex-col items-start gap-2 w-full {$$props.class}">
    {#if label}
      <label class="text-garden-grey-600 font-medium text-sm" for="">
        {#if label}{label}{:else}&nbsp;{/if}
        {#if required}<span class="text-red-500">*</span>{/if}
      </label>
    {/if}

    <input
      min="0"
      {...{ type: type || 'text' }}
      {name}
      {pattern}
      {autocomplete}
      class="{additionalInputClasses} input-selected w-full min-h-[54px] border border-garden-grey-300 rounded-14 p-4 placeholder:text-garden-grey-400 text-garden-grey-600 outline-none ease-out duration-100 read-only:opacity-70"
      class:input-danger={danger}
      bind:value
      on:blur={() => {
        const num = parseInt(value,10);
        if (num && num < 0) {
          value = '0';
          danger = true;
          dangerMessage = 'Negative numbers are not allowed';
        }
        dispatch('blur');
      }}
      on:focus={() => {
        danger = false;
        dangerMessage = null;
        dispatch('focus');
      }}
      on:keydown={event => {
        if (event.key === 'Enter') {
          handleSubmit();
        } else if (['Backspace', 'ArrowRight', 'ArrowLeft', 'Delete'].includes(event.key)) {
          if (inputVerifing) {
            verifyInput(event);
          }
        }
      }}
      {required}
      {placeholder}
      {readonly}
    />
    {#if !hideCaption}
      <SimpleCaption {danger} {dangerMessage} {caption} />
    {/if}
  </div>
{:else}
  <div class="flex flex-col items-start gap-2 w-full {$$props.class}">
    {#if label}
      <label class="text-garden-grey-600 font-medium text-sm" for="">
        {label || ''}
        {#if required}<span class="text-red-500">*</span>{/if}
      </label>
    {/if}

    <!-- svelte-ignore a11y-autofocus -->
    <input
      type="password"
      {autocomplete}
      {pattern}
      class="{additionalInputClasses} input-selected w-full min-h-[54px] border border-garden-grey-300 rounded-14 p-4 placeholder:text-garden-grey-400 text-garden-grey-600 outline-none ease-out duration-100 read-only:opacity-70"
      class:input-danger={danger}
      bind:value
      on:blur
      on:focus
      on:keydown={event => {
        if (event.key === 'Enter') {
          handleSubmit();
        }
      }}
      {required}
      {placeholder}
      {readonly}
      {autofocus}
    />
    {#if !hideCaption}
      <SimpleCaption {danger} {dangerMessage} {caption} />
    {/if}
  </div>
{/if}

<style type="postcss">
  .input-selected:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ecefff;
  }
  .input-danger {
    @apply border-accent-red-40;
  }
  .input-danger:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ffecec;
  }
</style>
